import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  /**
   * This regex matches on 4 groups.
   * It uses Unicode character class matching (`\p{L}` and `\p{N}`) to attempt to match international domain names.
   * It also matches explicitly on ASCII ranges in case Unicode character classes are not recognized.
   *
   * (http[s]?:\/\/){0,1}               starts with http:// or https:// (may be omitted)
   * ([A-Za-z0-9\p{L}\p{N}-]+\.)+       any sequence of characters, numbers or hyphens followed by a dot (repeated one or more times)
   * ([A-Za-z0-9\p{L}\p{N}]{2,61})      any sequence of 2-61 letters or numbers (top-level domain, or last part of an IP address)
   * ([\/?#:][A-Za-z0-9\p{L}\p{N}\-_?#&:~@!$',;=\.\[\]\(\)\*\+%]*)*    valid delimiter, followed by any sequence of valid URL characters (repeated zero or more times)
   */
  static WEBSITE_REGEX =
    /^(http[s]?:\/\/){0,1}([A-Za-z0-9\p{L}\p{N}-]+\.)+([A-Za-z0-9\p{L}\p{N}]{2,61})([\/?#:][A-Za-z0-9\p{L}\p{N}\-_?#&:~@!$',;=\.\[\]\(\)\*\+%]*)*$/u;
  /**
   * This regex follows the RFC 8141 syntax for URNs.
   *
   * urn:                                                 the URN scheme
   * [A-Za-z0-9](?:[A-Za-z0-9-]{0,30}[A-Za-z0-9])?        namespace identifier, up to 32 characters, starting and ending with a letter or number
   * (?:[A-Za-z0-9\-._~!$&'()*+,;=:@\/]|%[0-9A-Fa-f]{2})+    namespace specific string, either valid characters or percent-encoded octets
   */
  static URN_REGEX =
    /^urn:[A-Za-z0-9](?:[A-Za-z0-9-]{0,30}[A-Za-z0-9])?:(?:[A-Za-z0-9\-._~!$&'()*+,;=:@\/]|%[0-9A-Fa-f]{2})+$/;
  /**
   * SAML defines an entityID as a URI, which includes URLs (e.g. `https://idp.example.edu/idp/shibboleth`)
   * and URNs (e.g. `urn:mace:incommon:example.edu`).
   */
  static SSO_ENTITY_ID_REGEX = new RegExp(
    `${ValidationService.URN_REGEX.source}|${ValidationService.WEBSITE_REGEX.source}`,
    'u',
  );
  static EMAIL_REGEX =
    /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  static CERTIFICATE_REGEX =
    /^-----BEGIN CERTIFICATE-----[\s\S]*-----END CERTIFICATE-----$/;
  static PHONE_REGEX = /^[\+]?[1-9][\d]{0,15}$/;
}
